import { useEffect, useState } from "react";
import { LoggingHandler } from "./contexts/logging/LoggingContext";

type EventHandle = () => void;
export default class EventHandler<T extends string> {
    private events: Record<T, EventHandle[]> = Object.create(null);

    public on(event: T, handler: EventHandle) {
        this.events[event] ??= [];
        this.events[event].push(handler);
    }

    public off(event: T, handler: (() => void)) {
        const list = this.events[event];
        if (!list) {
            return;
        }
        const index = list.findIndex(row => row === handler);
        if (index >= 0) {
            list.splice(index, 1);
        }
    }

    public clearEvents(event: T) {
        this.events[event] = [];
    }

    public emit(event: T) {
        this.events[event]?.forEach(handler => LoggingHandler.instance.wrap(handler));
    }

    public useEvent(...event: T[]) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [generation, setGeneration] = useState<number>(0);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            const handler = () => {
                setGeneration(curr => curr + 1);
            };
            event.forEach(current => this.on(current, handler));

            return () => {
                event.forEach(current => this.off(current, handler));
            };
        }, [this]);

        return generation;
    }
}
